import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'

import { useForceUpdate, useReducerWithThunk } from '@hooks'
import { TOAST_TYPE } from '@base'
import { strings } from '@constants'
import { getSpoById } from '@data'
import { getActiveCommodity } from '@utils'
import { showLoader, showToast } from '@data/state/action'
import { initialStateSpo, reducer } from '../state/reducer'
import { clearSpoState, createNewSpo, createNewSpoFromData, fetchAllClients, fetchBrands, fetchCategories } from '../state/actions'
import SPOFormV2 from './SPOFormV2'

// Dummy-route container for the redesigned (v2) SPO flow — handles BOTH create and edit.
// When a :spoId param is present (edit route) it fetches the SPO and mounts the form in edit mode.
// Uses the SAME reducer/actions as the old flow; the old spo routes are left untouched.
const CreateSPOV2 = () => {
	const globalDispatch = useDispatch()
	const navigate = useNavigate()
	const { spoId } = useParams()
	const [state, dispatch] = useReducerWithThunk(reducer, initialStateSpo)
	const [forceUpdate, update] = useForceUpdate()
	const user = useSelector((_state) => _state.getIn(['user', 'user']))
	// Suppliers, categories and brands are all scoped to the commodity the user is working on —
	// same filters the create-enquiry flow sends.
	const commodityFilter = getActiveCommodity(user)

	useEffect(() => {
		dispatch(fetchAllClients(globalDispatch, commodityFilter?.commodity_id))
		dispatch(fetchCategories(commodityFilter?.commodity_name))
		dispatch(fetchBrands(commodityFilter?.commodity_id))

		if (spoId) {
			globalDispatch(showLoader(true))
			getSpoById(spoId)
				.then((response) => {
					dispatch(createNewSpoFromData(response))
				})
				.catch(() => {
					navigate(-1)
					globalDispatch(showToast(true, strings('msg_error_fetch_spo'), { type: TOAST_TYPE.ERROR }))
				})
				.finally(() => {
					globalDispatch(showLoader(false))
				})
		} else {
			dispatch(createNewSpo())
		}

		return () => {
			dispatch(clearSpoState())
		}
	}, [spoId, forceUpdate])

	return <SPOFormV2 state={state} dispatch={dispatch} update={update} edit={!!spoId} />
}

export default CreateSPOV2
